import { axiosInstance } from "../utils/axiosInterceptor";

export const GetEventListService = async (data) => {
  return await axiosInstance.post("get_event_list", data);
};

export const CreateEventService = async (data) => {
  return await axiosInstance.post("add_event", data);
};

export const UpdateEventService = async (data) => {
  return await axiosInstance.post("update_event", data);
};

export const GetEventDetailService = async (data) => {
  return await axiosInstance.post("get_event_by_id", data);
};

export const UpdateGalleryBtnStatusService = async (data) => {
  return await axiosInstance.post("update_gallery_btn_status", data);
};

export const GetEventUsersService = async (data) => {
  return await axiosInstance.post("user_list", data);
};

export const GetEventPhotosService = async (data) => {
  return await axiosInstance.post("photo_list", data);
};

export const AssignOrganizerService = async (data) => {
  return await axiosInstance.post("assign_event_to_user", data);
};

export const ImportFromDriveService = async (data) => {
  return await axiosInstance.post("add-drive-folder", data);
};

export const checkHashTagService = async (data) => {
  return await axiosInstance.post("check_event_hastag", data);
};

export const AddWhatsappNumberService = async (data) => {
  return await axiosInstance.post("add_whatsapp_number", data);
};

export const WhatsappNumberListService = async (data) => {
  return await axiosInstance.post("whatsapp_number_list", data);
};

export const ToggleImageVisibilityService = async (data) => {
  return await axiosInstance.post("move_to_gallery", data);
};

export const GetImageReport = async (data) => {
  return await axiosInstance.post("image_report_list", data);
};

export const UpdateEventPrivacyStatus = async (data) => {
  return await axiosInstance.post("make_public_private", data);
};

export const GetDashboardData = async (data) => {
  return await axiosInstance.get("dashboard_info", data);
};

export const GetDropBoxAuthUrl = async (data) => {
  return await axiosInstance.post("dropbox/auth", data);
};

export const GetDropBoxForceAuthUrl = async (data) => {
  return await axiosInstance.post("dropbox/auth/force", data);
};

export const DropBoxCallback = async (data) => {
  return await axiosInstance.post("dropbox/callback", data);
};

export const ImportFromDropboxService = async (data) => {
  return await axiosInstance.post("dropbox/addDropboxFolder", data);
};

export const ShareEventPicturesToggle = async (data) => {
  return await axiosInstance.post("share_picture_status", data);
};

export const EventAnalytics = async (data) => {
  return await axiosInstance.post("get_event_analytics", data);
};

export const GetEventWhatsappBilling = async (data) => {
  return await axiosInstance.post("get_event_whatsapp_billing", data);
};

export const ExportEventAnalyticsCsv = async (data) => {
  return await axiosInstance.post("export_event_analytics_csv", data, { responseType: "blob" });
};

export const GetGoogleDriveFolders = async (data) => {
  return await axiosInstance.post("get_drive_folder", data);
};

export const GetDropBoxDriveFolders = async (data) => {
  return await axiosInstance.post("dropbox/getDropboxFolder", data);
};

export const RefreshGoogleDriveFolder = async (data) => {
  return await axiosInstance.post("add-drive-folder", data);
};

export const RefreshDropBoxFolder = async (data) => {
  return await axiosInstance.post("dropbox/addDropboxFolder", data);
};

export const AddEventWatermark = async (data) => {
  return await axiosInstance.post("add_watermark", data);
};

export const UpdateWhatsappFlowStatus = async (data) => {
  return await axiosInstance.post("update_whatsapp_flow_status", data);
};

export const UpdateWebFlowStatus = async (data) => {
  return await axiosInstance.post("update_web_flow_status", data);
};

export const UpdateWebSharePictureStatus = async (data) => {
  return await axiosInstance.post("update_web_share_picture_status", data);
};

export const UpdateIframeEmbedStatus = async (data) => {
  return await axiosInstance.post("update_iframe_embed_status", data);
};

export const GetDesktopAppsService = async () => {
  return await axiosInstance.get("get_desktop_apps");
};

export const GetEventWebhookSettings = async (data) => {
  return await axiosInstance.post("get_event_webhook_settings", data);
};

export const GenerateEventWebhookSecret = async (data) => {
  return await axiosInstance.post("generate_event_webhook_secret", data);
};

// Data retention policy — background zip export of an event's user-uploaded
// photos (see CronController::generateUserUploadedPhotosZip in the backend).
export const RequestZipExport = async (data) => {
  return await axiosInstance.post("request_zip_export", data);
};

export const GetZipExportStatus = async (data) => {
  return await axiosInstance.post("get_zip_export_status", data);
};

export const SendZipUrlToOrganizers = async (data) => {
  return await axiosInstance.post("send_zip_url_to_organizers", data);
};

// Data retention policy — the admin "Confirm Deletion" gate (see
// ApiController::getEventRetentionStatus/confirmEventRetentionDeletion).
export const GetEventRetentionStatus = async (data) => {
  return await axiosInstance.post("get_event_retention_status", data);
};

export const ConfirmEventRetentionDeletion = async (data) => {
  return await axiosInstance.post("confirm_event_retention_deletion", data);
};
